/* eslint-disable max-len */
/* eslint-disable react/no-unknown-property */
/* jscs:disable maximumLineLength */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

class Exclamation extends PureComponent {
  render = () => (
    <SvgIcon {...this.props} viewBox="0 0 10 32" style={{ fontSize: this.props.fontSize }}>
      <path
        d="M10 27c0 1.375-.4896 2.552-1.4688 3.5312C7.5521 31.5104 6.375 32 5 32s-2.552-.4896-3.5313-1.4688C.4896 29.5521 0 28.375 0 27s.4896-2.552 1.4687-3.5312C2.448 22.4896 3.625 22 5 22s2.552.4896 3.5312 1.4688C9.5104 24.4479 10 25.625 10 27zM.5625 1.5626c0-.4167.1458-.7813.4375-1.0938.2917-.3125.6458-.4687 1.0625-.4687h5.875C8.354 0 8.7083.1563 9 .4688c.2916.3125.4375.6771.4375 1.0938l-.875 17c0 .4166-.1459.7603-.4375 1.0312-.2917.2708-.6459.4062-1.0625.4062h-4.125c-.4167 0-.7708-.1354-1.0625-.4062-.2917-.2709-.4375-.6146-.4375-1.0313l-.875-17z"
        fill="#FFF"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
}

Exclamation.propTypes = {
  fontSize: PropTypes.string,
};

export default Exclamation;
